import { InputsDaterange } from 'mixs/inputs/daterange';
const Japanese = require("flatpickr/dist/l10n/ja.js").Japanese;
Japanese['rangeSeparator'] = ' to ';
export class InputsSearchDaterange extends InputsDaterange {
  datePickerOptions(){
    return {
      mode:   "range",
      wrap: false,
      locale: Japanese,
      onChange: this.onChangePickr
    };
  }
  onChangePickr(selectedDates, dateStr, instance) {
    let value = this.dateInput().value;
    let newValue = ''
    if(value.match(this.formatDisplay())){
      newValue = value.replace(/ to /, ',')
    }
    this.dispatch({ value: newValue });
  }
}
riot.mixin("inputs.search.daterange", InputsSearchDaterange as riot.TagMixin)
